import React, { useRef, useState } from 'react';
import PrematchResults from './PrematchResults';
import SearchDataProvider from './SearchDataProvider';
import useIsLiveSection from '../useIsLiveSection';
import LiveResults from './LiveResults';
import OverlayWrapper from '../OverlayWrapper';
import { getLabel } from '../../data/labels';

export default function Search(props) {
    const isLiveSection = useIsLiveSection();

    const [search, setSearch] = useState('');
    const ref = useRef(null);

    function handleChange(event) {
        setSearch(event.target.value);
    }

    function handleReset() {
        ref.current.value = '';
        ref.current.focus();
        setSearch('');
    }

    return (
        <OverlayWrapper id="xs-search-overlay">
            <div className="xs_searchResultsDropdown z-30 absolute container top-0 left-0 right-0 bottom-0">
                <div className="h-full overflow-y-auto flex flex-col bg-cs1">
                    <div className="z-20 sticky top-0 shrink-0 h-[50px] grid grid-cols-12 items-center border-b border-b-cs7 bg-cs1">
                        <div className="col-start-1 col-end-3 justify-self-center inline-block" onClick={props.toggle}>
                            <i className="bi-arrow-left font-medium text-lg text-cs-3"></i>
                        </div>
                        <input className="col-start-3 col-end-11 px-2 font-medium text-lg text-cs-3 outline-0"
                            placeholder={getLabel('general.search')}
                            onChange={handleChange}
                            ref={ref}
                            autoFocus />
                        <div className="col-start-11 col-end-13 justify-self-center font-normal text-sm text-cs-3">
                            <i className="bi-x-lg mx-auto font-medium text-lg text-cs-3" onClick={handleReset}></i>
                        </div>
                    </div>
                    {search.length > 3 &&
                        (isLiveSection ?
                            <LiveResults search={search} toggle={props.toggle} />
                            :
                            <SearchDataProvider>
                                <PrematchResults search={search} toggle={props.toggle} />
                            </SearchDataProvider>
                        )
                    }
                </div>
            </div>
        </OverlayWrapper>
    );
}
